// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-accent-color: #3F8DA8;
  --secondary-accent-color: #92E0E5;
  --font: "Raleway", sans-serif;
  --button-padding: 10px;
  --button-background: white;
  --button-color: #3F8DA7;
  --button-border-width: 4px;
  --dog-width: 132px;
  --dog-height: 35px;
  --dog-font-size: 17px;
}`, "",{"version":3,"sources":["webpack://./src/css/variables.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":[":root {\n  --main-accent-color: #3F8DA8;\n  --secondary-accent-color: #92E0E5;\n  --font: \"Raleway\", sans-serif;\n  --button-padding: 10px;\n  --button-background: white;\n  --button-color: #3F8DA7;\n  --button-border-width: 4px;\n  --dog-width: 132px;\n  --dog-height: 35px;\n  --dog-font-size: 17px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
